export enum EmailBodyType {
    CONTACT = "CONTACT",
    REORDER = "REORDER"
}